import { AssessmentMain } from "@/components/assessment/AssessmentMain";
import { IAssessmentData } from "@/interfaces/IAssessmentData";
import assessmentService from "@/libs/services/assessmentService";
import { GetServerSideProps } from "next";


type props = {
    assessmentData: IAssessmentData
}
const selfAssessment = ({ assessmentData }: props) => {

    return <><AssessmentMain assessmentData={assessmentData}/></>
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const leadCategories = await assessmentService.getCategories()
    if (!leadCategories || leadCategories.length === 0)
        return {
            notFound: true
        }
    return {
        props: {
            assessmentData: {
                leadCategories: leadCategories
            }
        },
    };
}
export default selfAssessment;